import { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useMetro } from '../context/MetroContext'

const navLinks = [
  { to: '/', label: 'Home' },
  { to: '/route', label: 'Route Planner' },
  { to: '/fare', label: 'Fare Calculator' },
  { to: '/map', label: 'Metro Map' },
  { to: '/stations', label: 'Stations' },
  { to: '/about', label: 'About' },
]

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { currentCity, selectedCity } = useMetro()

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="container-responsive">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-10 h-10 bg-gradient-cta rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">M</span>
            </div>
            <div className="hidden sm:block">
              <span className="font-bold text-xl text-neutral-dark">
                {currentCity ? currentCity.metroName : 'Indian Metro'}
              </span>
              {currentCity && (
                <span className="block text-xs text-neutral-dark/60">
                  {currentCity.authorityAbbr}
                </span>
              )}
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-lg font-medium transition-colors tv-focusable ${
                    isActive
                      ? 'bg-metro-blue-soft text-metro-blue'
                      : 'text-neutral-dark hover:bg-gray-100'
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>

          {/* City Selector (Desktop) */}
          <div className="hidden lg:flex items-center gap-3">
            {selectedCity && (
              <div className="flex items-center gap-2 px-3 py-1 bg-metro-green-soft rounded-full text-sm">
                <span className="w-2 h-2 rounded-full bg-metro-green"></span>
                <span className="font-medium">{currentCity?.name}</span>
              </div>
            )}
            <Link
              to="/cities"
              className="btn-secondary text-sm py-2 px-4"
            >
              {selectedCity ? 'Change City' : 'Select City'}
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 tv-focusable"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t">
            {/* Current City Badge (Mobile) */}
            {selectedCity && (
              <div className="flex items-center gap-2 px-4 py-2 mb-2">
                <span className="w-2 h-2 rounded-full bg-metro-green"></span>
                <span className="font-medium">{currentCity?.name}</span>
                <span className="text-neutral-dark/50">|</span>
                <span className="text-neutral-dark/70">{currentCity?.authorityAbbr}</span>
              </div>
            )}

            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  onClick={() => setIsMenuOpen(false)}
                  className={({ isActive }) =>
                    `px-4 py-3 rounded-lg font-medium transition-colors ${
                      isActive
                        ? 'bg-metro-blue-soft text-metro-blue'
                        : 'text-neutral-dark hover:bg-gray-100'
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
              <Link
                to="/cities"
                onClick={() => setIsMenuOpen(false)}
                className="mt-2 btn-primary text-center"
              >
                {selectedCity ? 'Change City' : 'Select City'}
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}

export default Navbar
